module.exports = __webpack_public_path__ + "img/oil.1967729.jpg";